import { useEffect } from "react";
import { getUser } from "@/services/service-layer/userService";
import { isEmpty } from "@/utilities/utils";
import { MVAS, PLAN_MODE } from "@/utilities/constants";
import { useUsersStore } from "@/zustand/usersStore";

const useUser = () => {
  const user = useUsersStore((state) => state.user);
  const {
    vertical,
    translations,
    accountFeatures,
    id,
    planMode,
    planType,
    trialExpiresAt,
    sensorIntegrated,
    deactivatedAt,
  } = user;

  useEffect(() => {
    if (isEmpty(user)) {
      getUser();
    }
  }, []);
  const expiresDate = new Date(trialExpiresAt);
  const now = new Date();
  const isTrialAccountExpired =
    planMode === PLAN_MODE.FREE && now > expiresDate;

  return {
    user,
    isMVAS: vertical === MVAS,
    translations,
    accountFeatures,
    id,
    planMode,
    planType,
    trialExpiresAt,
    sensorIntegrated,
    isTrialAccountExpired,
    deactivatedAt,
  };
};

export default useUser;
